"use client";

import { ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { BattlefieldCard } from "@/components/ui/card";

export function NotFoundState() {
  const router = useRouter();

  return (
    <div className="battlefield-bg-pattern min-h-screen bg-background">
      <div className="relative mx-auto max-w-4xl px-4 py-12 text-center">
        <BattlefieldCard className="p-12">
          <h1 className="battlefield-text-glow mb-4 font-bold font-heading text-4xl text-foreground">
            LOADOUT NOT FOUND
          </h1>
          <p className="mb-8 text-lg text-muted-foreground">
            The requested loadout doesn't exist or is not available.
          </p>
          <Button
            className="battlefield-button font-mono text-primary-foreground"
            onClick={() => router.back()}
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            GO BACK
          </Button>
        </BattlefieldCard>
      </div>
    </div>
  );
}
